// extracted by mini-css-extract-plugin
module.exports = {"award":"award_award__7HeyI","award__icon":"award_award__icon__5dQr0"};